/**
 * Last Clicked Service
 */

DM.Service.LastClicked = (function () {

    var URL_ENDPOINT = '/lastclickedproducts/get';

    return {
        _fetchProductsFromServer: function (param) {
            return fetch(URL_ENDPOINT + param).then(response => response.json());
        },

        getProducts: function (forcePreviewParam = '') {
            return new Promise((resolve, reject) => {
                this._fetchProductsFromServer(forcePreviewParam)
                    .then(function (response) {
                        resolve(response);
                    }.bind(this))
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }
    };
})();
